<template>
  <div id="churujinList">
    <div class="searchBox">
      <div class="left">
        <el-date-picker v-model="value1" type="datetimerange" :range-separator="$fanyi('')"
          :start-placeholder="$fanyi('开始日期')" :default-time="['00:00:00', '23:59:59']" :end-placeholder="$fanyi('结束日期')"
          format="yyyy-MM-dd" value-format="yyyy-MM-dd">
        </el-date-picker>
        <button class="searchBtn" @click="getData">
          {{ $fanyi('搜索') }}
        </button>
      </div>
      <span class="getMoneyHistory" @click="$fun.toPage('/user/WithdrawalRecord')">{{ $fanyi('提现记录') }}</span>

    </div>
    <div class="dataBody" v-loading="loading">
      <el-table :data="tableData" border :header-cell-style="{
        background: '#F5F5F5',
        height: '50px',
        'font-size': '14px',
        border: 'none',
        color: '#121212',
        'font-weight': '500',
        'text-align': 'center',
      }" :cell-style="{
        'text-align': 'center',
        color: '#121212',
        'font-size': '14px',
        height: '60px',
      }" cell-class-name="cellClassName" header-row-class-name="cellHeadClassName">
        <el-table-column type="index" width="50" label="No"> </el-table-column>
        <el-table-column property="confirm_at" :label="$fanyi('日期')" width="100"></el-table-column>
        <el-table-column property="order_sn" :label="$fanyi('订单号')" width="200">
          <template slot-scope="scope">
            <div class="orderBtn">
              <span v-if="scope.row.order_sn.substr(0, 1) == 'P'" @click="
                $fun.toPage('/deliveryDetails?order_sn=' + scope.row.order_sn)
                ">
                {{ scope.row.order_sn }}
              </span>
              <span v-else @click="
                $fun.toPage(
                  '/orderDetails?type=' + scope.row.order.status_name +
                  '&order_sn=' +
                  scope.row.order_sn
                )
                ">
                {{ scope.row.order_sn ? scope.row.order_sn : '---' }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="bill_type" :label="$fanyi('交易类型')" width="170">
          <template slot-scope="scope">
            <div>
              {{ $fanyi(scope.row.bill_type) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="bill_method" :label="$fanyi('支付方式')" width="110">
          <template slot-scope="scope">
            <div>
              {{ $fanyi(scope.row.bill_method) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="pay_remark" :label="$fanyi('明细')" width="130">
          <template slot-scope="scope">
            <div>
              <el-popover placement="bottom-start" trigger="click">
                <div class="changesInDetail">
                  <h1>
                    {{ $fanyi('金额变动明细') }}
                  </h1>

                  <div v-if="scope.row.adjust_detail &&
                    scope.row.adjust_detail.length > 0
                  ">
                    <div class="changeList" v-for="(listItem, listIndex) in scope.row.adjust_detail" :key="listIndex">
                      <p v-for="(item, index) in listItem" :key="index">
                        {{ $fanyi(item) }}
                      </p>
                    </div>
                  </div>
                  <!-- <div v-else>
                    <p>{{ $fanyi(scope.row.client_bill_reason) }}</p>
                  </div>
                  <div v-if="scope.row.pay_remark">
                    <p>{{ $fanyi(scope.row.pay_remark) }}</p>
                  </div> -->
                </div>
                <span class="detail" v-if="scope.row.adjust_detail &&
                  scope.row.adjust_detail.length > 0
                " slot="reference">
                  {{ $fanyi('明细') }}
                </span>
                <span v-else slot="reference">
                  ---
                </span>
              </el-popover>
            </div>
          </template>
        </el-table-column>

        <el-table-column property="amount" width="120" :label="$fanyi('收支')">
          <template slot-scope="scope">
            <div>₴{{ $fun.EURNumSegmentation(scope.row.amount) }}</div>
          </template>
        </el-table-column>
        <el-table-column property="balance" :label="$fanyi('账户余额')">
          <template slot-scope="scope">
            <div>₴{{ $fun.EURNumSegmentation(scope.row.balance) }}</div>
          </template></el-table-column>
      </el-table>
    </div>
    <div class="allpag">
      <span></span>
      <el-pagination @current-change="handleCurrentChange" :current-page="form.currentPage" :page-size="10"
        :page-sizes="[10, 20, 30, 50]" layout="total,prev, pager, next,jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      value1: [],
      form: {
        status: this.$fanyi('待处理'),
        page: 1,
        pageSize: 10,
        searchText: '',
        startTime: '',
        endTime: '',
      },
      loading: false,
      tableData: [],
      total: 0,
      tableOption: [], //表格显示哪些选项
      ordersSumList: {}, //商品列表各种类商品数据
    }
  },
  created() {
    // this.form.startTime = getCurrentMonthFirst() + " 00:00:00";
    // this.form.endTime = getCurrentMonthLast() + " 23:59:59";
    // this.value1 = [
    //   getCurrentMonthFirst() + " 00:00:00",
    //   getCurrentMonthLast() + " 23:59:59",
    // ];
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      this.$api
        .capitalBillList({
          status: this.form.status,
          pageSize: this.form.pageSize,
          page: this.form.page,
          startTime: this.value1 ? this.value1[0] : '',
          endTime: this.value1 ? this.value1[1] : '',
          keywords: this.form.searchText,
        })
        .then((res) => {
          this.loading = false
          if (res.code != 0) return
          this.tableData = res.data.data
          this.total = res.data.total
        })
    },
    handleCurrentChange(val) {
      this.form.page = val
      this.getData()
    },
  },
  components: {},
  computed: {},
}
</script>
<style>
.el-popover {

  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  border: 1px solid #dfdfdf;
  padding: 20px;
}
</style>
<style lang="scss" scoped>
#churujinList {
  @import '../../../../css/mixin';
  width: 1060px;

  background: #ffffff;
  border-radius: 20px;
  padding: 30px 20px;

  .searchBox {
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;

    .left {
      /deep/.el-date-editor {
        border-radius: 12px;
        width: 296px;
        height: 40px;
        margin-right: 20px;
        line-height: 32px !important;

        .el-input__inner {
          padding: 0px !important;
          border-radius: 12px;
        }

        .el-range__icon {
          display: none;
        }

        .el-range-input {
          font-size: 14px;
          border-radius: 12px;
        }

        .el-range-separator {
          width: 50px;
          line-height: 23px;
        }

        .el-range__icon {
          line-height: 25px;
        }
      }

      .searchBtn {
        width: 80px;
        height: 40px;
        background: #d12a1d;
        border-radius: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 24px;
        text-align: center;
        font-size: 14px;
      }
    }

    .getMoneyHistory {
      min-width: 160px;
      height: 40px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 16px;
      color: #d12a1d;
      padding: 0 10px;
      border: 1px solid #d12a1d;

      &:hover {
        cursor: pointer;
      }
    }
  }


  /deep/.el-table {
    border-radius: 12px;

    overflow: hidden;
    border-bottom: none;
    border-color: #dfdfdf;

    .el-table__cell {
      border-color: #dfdfdf;

    }

    tr {
      border-color: #dfdfdf;

      &:last-child {


        overflow: hidden;

        td {

          &:first-child {
            border-radius: 0 0 0px 12px;
          }

          &:last-child {
            border-radius: 0 0 12px 0px;
          }

        }
      }
    }

    .el-table__empty-block {
      border-radius: 0 0 12px 12px;
    }
  }

  /deep/.el-table__header-wrapper {

    border-bottom: 1px solid #dfdfdf;

    .cell {
      line-height: 14px;
    }

    /deep/.el-table__empty-block {
      height: 80px !important;
      border-bottom: 0.5px solid #dfdfdf;
    }
  }



  .dataBody {
    min-height: 180px;


    .orderBtn {
      font-weight: 400;
      font-size: 14px;
      color: #d12a1d;
      line-height: 20px;

      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
    }

    .detail {
      font-weight: 400;
      font-size: 14px;
      color: #2052ce;
      line-height: 16px;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .allpag {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 30px 0px;

    .el-pagination {
      display: flex;
      align-items: center;
    }

    >a {
      display: inline-block;
      border: 1px solid #dcdfe6;
      height: 28px;
      // background-color: white;
      text-align: center;
      padding: 0 10px;
      font-size: 13px;
      line-height: 28px;
      border-radius: 0;
    }

    /deep/.btn-prev {
      width: 30px;
      height: 30px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #dfdfdf;
      padding: 0;
      margin-right: 15px;
      margin-left: 20px;

      .el-icon {
        font-size: 16px;
        color: #000000;
      }
    }

    /deep/.btn-next {
      width: 30px;
      height: 30px;
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #dfdfdf;
      padding: 0;
      margin-left: 15px;

      .el-icon {
        font-size: 16px;
        color: #000000;
      }
    }

    /deep/ .el-pagination__jump {
      .el-input {
        width: 50px;
        height: 30px;
        background: #ffffff;
        border-radius: 8px;
        margin-left: 5px;

        font-weight: 400;
        font-size: 14px;
        color: #000000;

        .el-input__inner {
          height: 30px;
          border-radius: 8px;
        }
      }
    }

    /* 分页被选中的页码样式 */
    /deep/ .el-pager li {
      margin: 0 5px;
      width: 30px;
      line-height: 30px;
      height: 30px;
      border-radius: 8px;
      // box-shadow: 0 0 6px 0 rgba(61, 61, 61, 0.1);

      &:hover {
        color: #d12a1d;
      }

      &.active {
        width: 30px;

        height: 30px;
        background: #d12a1d;
        line-height: 30px;
        color: #fff;
        border-radius: 8px;
      }
    }
  }
}



.changesInDetail {
  color: black;

  h1 {
    font-weight: 550;
    font-size: 16px;
    color: #121212;
    line-height: 24px;

    margin-bottom: 8px;
  }

  .changeList {


    p {
      min-height: 28px;
      font-size: 14px;
      color: #121212;

    }
  }
}
</style>
